<template>
  <component :is="component">
    <router-view />
  </component>
</template>

<script>
import Auth               from '../../mixins/auth'
import TransactionsAdmin  from './TransactionsAdmin'
import TransactionsDealer from './TransactionsDealer'

export default {
  name      : 'Transactions',
  // eslint-disable-next-line vue/no-unused-components
  components: { TransactionsDealer, TransactionsAdmin },
  directives: {},
  mixins    : [Auth],
  props     : {},
  data () {
    return {}
  },
  computed: {
    component () {
      return this.userIsDealer ? TransactionsDealer.name : TransactionsAdmin.name
    }
  },
  watch: {},
  beforeCreate () {
  },
  created () {
  },
  beforeMount () {
  },
  mounted () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  },
  methods: {}
}
</script>

<style scoped>

</style>
